<template>
  <!-- -->
  <div class="defaultViewStyle">
    <list-page>
      <list-table background-color="#FFF" :show-shadow="false">
        <form-items :data="dataDetail" :columns="2">
          <form-item label="企业微信id">
            {{dataDetail.qywxOrderId}}
          </form-item>
          <form-item label="商户名称">
            {{dataDetail.merchantName}}
          </form-item>
          <form-item label="账号类型">
            {{dataDetail.accountType === 1? '基础账号': '互通账号'}}
          </form-item>
          <form-item label="账号数量">
            {{dataDetail.accountNumber}}
          </form-item>
          <form-item label="账号时长">
            {{dataDetail.accountDuration}} 个月
          </form-item>
          <form-item label="订单状态">
            <div v-if="dataDetail.orderStatus === 0">待支付</div>
            <div v-if="dataDetail.orderStatus === 1">已支付</div>
          </form-item>
        </form-items>
        <yq-table :data="dataDetail.qywxOrderAccounts" height="auto">
          <yq-table-column label="账号类型">
            <template v-slot="scope">
              <div v-if="scope.row.accountType === 1">基础账号</div>
              <div v-if="scope.row.accountType === 2">互通账号</div>
            </template>
          </yq-table-column>
          <yq-table-column label="激活码" prop="activeCode"/>
          <yq-table-column label="激活时间" prop="activeTime"/>
          <yq-table-column label="到期时间" prop="expireTime"/>
          <yq-table-column label="绑定账号" prop="qywxOpenId" min-width="120rem"/>
          <yq-table-column label="职员名称" prop="qywxOpenId">
            <template v-slot="{row}">
              <ww-open-data v-if="row.qywxOpenId" type="userName" :openid="row.qywxOpenId" />
            </template>
          </yq-table-column>
          <yq-table-column  label="操作" prop="options" align="center" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toSelectUser(row)">激活</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
    </list-page>
    <employee-select @change="selectEmployeeWeb" ref="employeeSelect"/>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import qywxOrderApi from "@/api/normal/sys/qywxOrderApi";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import qywxUtil from "@/util/qywxUtil";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import util from "@/util/util";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "QOD",
  components: {
    TableButtonGroup, TableButton, YqTableColumn, YqTable, PageButton, ListPage, ListTable, FormPage, FormItems, FormItem, EmployeeSelect
  },
  data() {
    return {
      dataDetail: {
        qywxOrderAccounts: []
      },
      currentData: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    // 注册企业微信通讯录组件
    qywxUtil.ready().then(() => {
      qywxUtil.initOpenData().then((res) => {
        console.log("注册通讯录组件成功", res)
        if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
          this.init();
        }
      });
    })
  },
  methods: {
    init() {
      this.findById(this.route.query.id);
    },
    findById(id) {
      qywxOrderApi.findById(id).then(data => {
        this.dataDetail = data;
        // 渲染完成后，显示用户名
        this.$nextTick().then(() => {
          qywxUtil.bindQywxName();
        })
      });
    },
    // 选中用户
    toSelectUser(data) {
      this.currentData = {...data};
      // 检查当前运行环境
      let context = util.getContextPath();
      if (context === 1) { // 这是web端
        this.toSelectUserWeb();
      } else if (context === 2) { // 这是企业微信PC端
        this.toSelectUserQywxPC();
      }


    },
    // 在web端，打开选择用户页面
    toSelectUserWeb() {
      this.$refs.employeeSelect.toSelectEmployee();
    },
    // 在web端，选择了某个用户
    selectEmployeeWeb(data) {
      this.activeAccount(data.qywxOpenId);
    },
    // 在企业微信端，打开通讯录页面进行选择
    toSelectUserQywxPC() {
      qywxUtil.ready().then(() => {
        // 打开通讯录
        qywxUtil.selectEmployeeSingle().then(qywxUserId => {
          this.activeAccount(qywxUserId);
        })
      })
    },
    // 激活账户
    activeAccount(qywxUserId) {
      qywxOrderApi.activeAccount({employeeId: qywxUserId, code: this.currentData.activeCode}).then(res => {
        this.$message.success("激活成功");
        this.init();
        console.log(res)
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.defaultViewStyle{
  :deep(.employee-selector-area) {
    position: absolute;
    bottom: -100px;
  }
}
</style>